import React, { useMemo, useState } from 'react'
import { Link } from 'gatsby'
import { Col, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { ImageGallery } from '/src/components/gallery'
import { PackageDimensions, filterVariation } from '/src/components/commerce/product/productUtil'
import { ProductVariationsForm } from '../form'
import ProductVariationsModal from '../modal/ProductVariationsModal'
import { ProductFavourite } from './ProductFavourite'

const ProductVariationView = ({ variation, product_id }) => {
  if (!variation) {
    return <></>
  }

  return (
    <div className="product-details-view">
      <ul className="product-variation-details-list">
        {product_id && (
          <li>
            <label>Product number:</label>
            <span>{product_id}</span>
          </li>
        )}
        {variation.field_prod_variation_reference && (
          <li>
            <label>Product reference:</label>
            <span>{variation.field_prod_variation_reference}</span>
          </li>
        )}
        {variation.title && (
          <li>
            <label>Product title:</label>
            <span>{variation.title}</span>
          </li>
        )}
        {variation.dimensions && (
          <li>
            <label>Product dimensions:</label>
            <span><PackageDimensions dimensions={variation.dimensions} /></span>
          </li>
        )}
        {variation.weight && variation.weight.number && (
          <li>
            <label>Weight:</label>
            <span>{Number(variation.weight.number).toPrecision(4)} {variation.weight.unit}</span>
          </li>
        )}
      </ul>
    </div>
  )
}

const ProductImageGallery = ({ field_product_images }) => {
  const images = useMemo(() => {
    return field_product_images.map(({ relationships }) => {
      return {
        image: relationships.field_media_image_2.url,
        content: null
      }
    })
  }, [])

  return <ImageGallery images={images} />
}

export const ProductView = ({ 
  title, 
  body,
  field_product_min_purchase,
  field_product_disclaimer, 
  field_product_features,
  field_product_optional_features,
  attributes_display, 
  dsap_product_ids, 
  relationships 
}) => {
  const [productVariation, setProductVariation] = useState(false)
  const { variations, field_product_images } = relationships

  const filteredVariations = useMemo(() => {
    return variations.filter(value => value.status !== false)
  }, [variations])
  const variation = useMemo(() => (
    productVariation && filterVariation(productVariation.id, variations)
  ), [productVariation, variations])

  const dsap_product_id = useMemo(() => {
    if (!variation) return null

    const result = dsap_product_ids.find(value => value.product_id === variation.drupal_id)
    if (!result || !result.dsap_product_id) return null

    return result.dsap_product_id
  }, [variation, dsap_product_ids])

  return (
    <Row className="mt-5">
      <Col className="mt-2" lg={6}>
        <div className="mb-5">
          <Link className="back-to-link" to='/products/all'>
            <FontAwesomeIcon icon={faArrowLeft} />
            Back to products
          </Link>
        </div>

        <div className="product-title-container mb-4">
          <h1 className="title mb-3">{title}</h1>
          <ProductFavourite {...variation} product_id={dsap_product_id} />
        </div>
        {productVariation && (
          <ProductVariationView variation={variation} product_id={dsap_product_id} />
        )}
        {body && (
          <div className="product-body mb-2" dangerouslySetInnerHTML={{
            __html: body.processed
          }}></div>
        )}
        {field_product_images && (
          <div className="product-gallery mt-4 mb-4">
            <ProductImageGallery field_product_images={field_product_images} />
          </div>
        )}
        {field_product_features && (
          <>
            <div className="product-title-container mb-3">
              <h4 className='title'>Features</h4>
            </div>
            <div className="product-features mt-2 features" dangerouslySetInnerHTML={{
              __html: field_product_features.processed
            }}></div>
          </>
        )}
        {field_product_disclaimer && (
          <>
            <div className="product-title-container mb-3">
              <h4 className='title'>Disclaimer</h4>
            </div>
            <div className="product-disclaimer mb-2 disclaimer" dangerouslySetInnerHTML={{
              __html: field_product_disclaimer.processed
            }}></div>
          </>
        )}
      </Col>
      <Col className="mt-2" lg={6}>
        <ProductVariationsForm
          variation={variation}
          variations={filteredVariations} 
          selectedVariation={productVariation} 
          setSelectedVariation={setProductVariation}
          attributesDisplay={attributes_display}
          minPurchase={field_product_min_purchase} />

        {field_product_optional_features && (
          <>
            <div className="product-title-container mb-3 mt-4">
              <h4 className='title'>Optional Features</h4>
            </div>
            <div className="product-features features mt-2" dangerouslySetInnerHTML={{
              __html: field_product_optional_features.processed
            }}></div>
          </>
        )}
      </Col>
      <ProductVariationsModal variations={filteredVariations} setProductVariation={setProductVariation} />
    </Row>
  )
}

export default ProductView